import { cn } from "@/app/lib/utils/cn";
import type { ReactNode } from "react";

interface BrandBadgeProps {
  goldText: string;
  pinkText: ReactNode;
  punc?: string;
  space?: boolean;
  small?: boolean;
  className?: string;
}

export default function BrandBadge({
  goldText,
  pinkText,
  punc,
  space,
  small,
  className,
}: BrandBadgeProps) {
  const sizeClass = small ? "text-sm" : "text-base md:text-lg lg:text-xl";
  return (
    <span>
      <b className={cn("bg-(--purple) p-1 rounded-md", sizeClass, className)}>
        <span className="text-(--gold)">{goldText}</span>
        <span className="text-(--brand)">
          {pinkText}
          {punc}
        </span>
      </b>
      {space && "\u00A0"}
    </span>
  );
}
